module.exports = __webpack_public_path__ + "static/media/heroku.fb3d05fe.png";